
import { Component, Vue } from 'vue-property-decorator';
import { Roles } from '@/modules/authentication/models/rolesEnum';
import { checkRole } from '@/modules/authentication/helpers/checkRole';
import QuickActions, { CardData } from '@/components/cta/QuickActions.vue';
import TextImage, { TextImageData } from '@/modules/home/components/TextImage.vue';

@Component({
  components: { QuickActions, TextImage }
})
export default class LandingPage extends Vue {
  protected cards: { data: CardData; to: unknown }[] = [];
  protected textImage: TextImageData = {
    title: this.$i18n.t('home.LandingPage.articles.title1').toString(),
    text: [
      this.$i18n.t('home.LandingPage.articles.paragraph1_1').toString(),
      this.$i18n.t('home.LandingPage.articles.paragraph1_2').toString()
    ],
    imageUrl: require(`@/assets/images/pictures/lab.jpg`)
  };

  protected created(): void {
    if (checkRole(Roles.requests_create)) {
      this.cards.push(
        {
          data: {
            title: this.$i18n.t('home.LandingPage.quickAction.newRequest.title').toString(),
            subtitle: this.$i18n.t('home.LandingPage.quickAction.newRequest.subtitle').toString(),
            icon: 'mdi-plus'
          },
          to: { name: 'NewAnalysis' }
        },
        {
          data: {
            title: this.$i18n.t('home.LandingPage.quickAction.dashboard.title').toString(),
            subtitle: this.$i18n.t('home.LandingPage.quickAction.dashboard.subtitle').toString(),
            icon: 'mdi-file-chart'
          },
          to: { name: 'AnalysisDashboard' }
        }
      );
    }
  }
}
